import { useEffect, useRef } from 'react';

import { useRouteLoaderData } from '@remix-run/react';

import type { RootLoaderData } from '~/root';

import { type MetaPixelParams, validMetaPixelId, whenMetaPixelReady } from './metaPixel';

export function useMetaPixelId(): string | null {
  const rootData = useRouteLoaderData('root') as RootLoaderData | undefined;
  const site = rootData?.site;

  return validMetaPixelId(site?.viewable_site_version?.settings?.meta_pixel_id || site?.publication?.facebook_pixel);
}

export function useMetaViewContent(contentKey: string | null | undefined, params: MetaPixelParams | null) {
  const pixelId = useMetaPixelId();
  const paramsRef = useRef(params);
  paramsRef.current = params;
  const hasParams = params !== null;

  useEffect(() => {
    if (!pixelId || !contentKey || !hasParams) return;

    let sent = false;
    return whenMetaPixelReady(pixelId, () => {
      const currentParams = paramsRef.current;
      if (sent || !currentParams || !window.fbq) return;
      sent = true;
      window.fbq('trackSingle', pixelId, 'ViewContent', currentParams);
    });
  }, [pixelId, contentKey, hasParams]);
}
